import maplibregl, { GeoJSONSource, SourceSpecification } from "maplibre-gl";
import fetchSoldPropertiesData, { BBox, SoldPropertiesPoiResult } from "../data/SoldPropertiesData.ts";
import { AppState } from "../AppState.ts";

function getBBoxFromMap(map: maplibregl.Map): BBox {
	const bounds = map.getBounds();
	return [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()];
}

function toGeoJSON(docs: SoldPropertiesPoiResult[]) {
	return {
		type: "FeatureCollection" as const,
		features: docs.map((item: SoldPropertiesPoiResult) => ({
			type: "Feature" as const,
			id: item.adId.toString(),
			geometry: {
				type: "Point" as const,
				coordinates: [item.lon, item.lat] as [number, number],
			},
			properties: {
				id: item.adId.toString(),
				name: item.adId.toString(),
				lon: item.lon,
				lat: item.lat,
			},
		})),
	};
}

export async function getSoldPropertiesSource(map: maplibregl.Map): Promise<SourceSpecification> {
	const state = new AppState();
	const bbox = getBBoxFromMap(map);
	const soldPropertiesData = await fetchSoldPropertiesData(state.proxyUrl, bbox);

	return {
		type: "geojson",
		data: soldPropertiesData ? toGeoJSON(soldPropertiesData.docs) : { type: "FeatureCollection", features: [] },
	};
}

export async function updateSoldPropertiesSource(map: maplibregl.Map) {
	const state = new AppState();
	const bbox = getBBoxFromMap(map);
	const soldPropertiesData = await fetchSoldPropertiesData(state.proxyUrl, bbox);

	if (!soldPropertiesData) return;

	const source = map.getSource("sold-properties-source") as GeoJSONSource | undefined;
	if (source) {
		source.setData(toGeoJSON(soldPropertiesData.docs));
	}
}
